export const en = {
    'preview-cancel': 'Cancel',
    'preview-select': 'Select'
};
